import React from "react"
import {
  Switch as MUISwitch,
  SwitchProps as MUISwitchProps,
} from "@mui/material"
import { MUIMappedSwitch } from "./mantine/Switch.mantine"

export type SwitchProps =
  | ({ new?: false } & MUISwitchProps)
  | ({ new: true } & MUISwitchProps)

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  (props, ref) =>
    props.new ? (
      <MUIMappedSwitch {...props} ref={ref} />
    ) : (
      <MUISwitch {...props} ref={ref} />
    ),
)

Switch.displayName = "Switch"

export default Switch
